module.exports = __webpack_public_path__ + "static/media/3-01-Tulleord-Intro.05691f0b.mp3";